import { render } from "./InstitutionDetails.vue?vue&type=template&id=1350200a"
import script from "./InstitutionDetails.vue?vue&type=script&lang=js"
export * from "./InstitutionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__